module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-18.e0d7ff2a.png";